import { defineMessages } from "react-intl";

export const extraImpactDialogMessages = defineMessages({
  titleStopsCounting: {
    id: "extrasCategories.extraImpact.title.stopsCounting",
    defaultMessage: "{extra} will stop counting against the limits",
  },
  titleCategoryRemoved: {
    id: "extrasCategories.extraImpact.title.categoryRemoved",
    defaultMessage: "The category will be removed",
  },
  titleCoverageLost: {
    id: "extrasCategories.extraImpact.title.coverageLost",
    defaultMessage: "{extra} will not be available in some accommodations",
  },
  titleDeactivation: {
    id: "extrasCategories.extraImpact.title.deactivation",
    defaultMessage: "Deactivate {extra}?",
  },
  titleCombined: {
    id: "extrasCategories.extraImpact.title.combined",
    defaultMessage: "Confirm changes to {extra}",
  },
  typeChangePreface: {
    id: "extrasCategories.extraImpact.typeChangePreface",
    defaultMessage:
      "Changing the type to {type} removes the category, licence plate and vehicle type of {extra}.",
  },
  emptyBlockPlace: {
    id: "extrasCategories.extraImpact.emptyBlockPlace",
    defaultMessage: "{accommodation} — {category}",
  },
  cancel: {
    id: "extrasCategories.extraImpact.cancel",
    defaultMessage: "Cancel",
  },
  continue: {
    id: "extrasCategories.extraImpact.continue",
    defaultMessage: "Continue",
  },
  blockedTitle: {
    id: "extrasCategories.extraImpact.blocked.title",
    defaultMessage: "This change cannot be saved",
  },
  close: {
    id: "extrasCategories.extraImpact.blocked.close",
    defaultMessage: "Close",
  },
});
